import React, { ChangeEvent, useEffect, useState } from "react";
import "./DashboardEntryPanasonicEndUserWidget.scss";
import UIService from "../../../services/UIService";
import INewAddress from "../../../models/INewAddress";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";

type Props = {
    updateDetails: (details: any) => void;
    sectionInEditMode: (section: string, inEditMode: boolean) => void;
};

export const DashboardEntryPanasonicEndUserWidget = (props: Props) => {
    const isMainViewLight = UIService.isMainViewLight();

    const [editMode, setEditMode] = useState(false);
    const [name, setName] = useState("");
    const [company, setCompany] = useState("");
    const [address, setAddress] = useState<INewAddress>({} as INewAddress);
    const [city, setCity] = useState("");
    const [province, setProvince] = useState("");
    const [postalCode, setPostalCode] = useState("");

    useEffect(() => {
        props.sectionInEditMode("end_user", editMode);
        if (!editMode) {
            props.updateDetails({
                name,
                company,
                address,
                city,
                province,
                postalCode,
            });
        }
    }, [editMode]);

    const toggleEditMode = () => {
        setEditMode(!editMode);
    };

    const labelClass = "w-7r text-end mb-3 me-2";

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const _name = e.target.name;

        switch (_name) {
            case "name":
                setName(value);
                break;

            case "company":
                setCompany(value);
                break;

            case "city":
                setCity(value);
                break;

            case "province":
                setProvince(value);
                break;

            case "postal_code":
                setPostalCode(value);
                break;
        }
    };

    const handleAddressChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const _name = e.target.name;

        const _address: INewAddress = { ...address };
        // @ts-expect-error
        _address[_name] = value;

        setAddress(_address);
    };

    return (
        <div className={"DashboardEntryPanasonicEndUserWidget col-3"}>
            <div className={"d-flex justify-content-between"}>
                <OwLabel title={"end_user"} isBold={true} />

                <OwLabel
                    title={editMode ? "save" : "edit"}
                    fn={() => {
                        toggleEditMode();
                    }}
                />
            </div>
            <div className={"card d-flex font-weight-bold card-header flex-grow h-100 " + (!isMainViewLight ? "text-white bg-dark" : "")}>
                <table className={"table " + (isMainViewLight ? "" : "table-dark")}>
                    <tbody>
                        <tr>
                            <th className={"text-end w-7r"}>
                                <OwLabel title={"name"} isBold={true} />
                            </th>
                            <td>{editMode ? <OwFnInput fn={handleChange} name={"name"} value={name} /> : name}</td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"company"} isBold={true} />
                            </th>
                            <td>{editMode ? <OwFnInput fn={handleChange} name={"company"} value={company} /> : company}</td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"address"} isBold={true} />
                            </th>
                            <td>
                                {editMode ? (
                                    <div className={"address-row"}>
                                        <div className={"mb-2"}>
                                            <OwFnInput
                                                fn={handleAddressChange}
                                                name={"address_line_one"}
                                                value={address.address_line_one}
                                            />
                                        </div>
                                        <div className={"mb-2"}>
                                            <OwFnInput
                                                fn={handleAddressChange}
                                                name={"address_line_two"}
                                                value={address.address_line_two}
                                            />
                                        </div>
                                        <div className={"mb-2"}>
                                            <OwFnInput
                                                fn={handleAddressChange}
                                                name={"address_line_three"}
                                                value={address.address_line_three}
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className={"address-row"}>
                                        <div className={"h-2r"}>{address.address_line_one}</div>
                                        <div className={"h-2r"}>{address.address_line_two}</div>
                                        <div className={"h-2r"}>{address.address_line_three}</div>
                                    </div>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"city"} isBold={true} />
                            </th>
                            <td>{editMode ? <OwFnInput fn={handleChange} name={"city"} value={city} /> : city}</td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"province"} isBold={true} />
                            </th>
                            <td>{editMode ? <OwFnInput fn={handleChange} name={"province"} value={province} /> : province}</td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"postal_code"} isBold={true} />
                            </th>
                            <td>{editMode ? <OwFnInput fn={handleChange} name={"postal_code"} value={postalCode} /> : postalCode}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
